'use client'

import { useEffect, useState } from "react";

const useLockScroll = () => {

    const [lockScroll, setLockScroll] = useState(false)

    useEffect(() => {
        if (lockScroll)
            document.body.style.overflow = "hidden";
        else
            document.body.style.overflow = "scroll";
        return () => {
            document.body.style.overflow = "scroll"
        };
    }, [lockScroll]);

    return (value: boolean) => setLockScroll(value)

}

export default useLockScroll;